import React, { useEffect, useState } from "react";
import "./orderModal.css";

import "reactjs-popup/dist/index.css";
import { useSelector } from "react-redux";
import { totalPrice } from "../../../../utils";
import axios from "axios";
import { setCustomConfigData } from "../../../../redux/actions/custom-config-data-action";
import { useDispatch } from "react-redux";
import { ConfigBaseUrl, VehicleCode } from "../../../../config";
import ComponentLoader from "../../../../components/componentLoader";
import { VehicleName } from "../../../../config";
import PrimaryButton from "../../../../components/primaryButton";
import crossicon from "../../../../assets/rr310/red-x.png";
import removeCart from "../../../../assets/remove_cart.png";

function PlaceOrder({ onOrderModal, orderModal, TermsClick, PrivacyClick }) {
  const [checked, setChecked] = useState(false);
  const [kitStaus, setKitStaus] = useState(false);
  const [toggleSwitch, setToggleSwitch] = useState(true);
  const [prebookData, setPrebookData] = useState({});
  const [orderCounter, setOrderCounter] = useState("");
  const [loader, setLoader] = useState(false);
  const [orderDetailsArr, setOrderDetailsArr] = useState([]);
  const [btoStatus, setBtoStatus] = useState(false);
  const [orderSumery, setOrderSumery] = useState([]);
  const [acceptStatus, setAcceptStatus] = useState(false);
  const [acceptMessage, setAcceptMessage] = useState([]);

  const dispatch = useDispatch();

  const customConfigData = useSelector((state) => state.customConfigData.data);
  const userData = useSelector((state) => state.userData.data);

  useEffect(() => {
    setAcceptMessage(customConfigData?.Notify?.Meta);
  }, [customConfigData]);

  useEffect(() => {
    try {
      setLoader(true);
      // const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      axios
        .get(ConfigBaseUrl() + "prebooking", {
          params: {
            vehicleCode: VehicleCode,
            // Phone: userDetails[0]?.MobileNumber,
            Phone: userData?.MobileNumber,
          },
        })
        .then(function (response) {
          if (response) {
            setPrebookData(response?.data);
            setLoader(false);
          }
        });
    } catch (error) {
    } finally {
    }
  }, []);

  useEffect(() => {
    try {
      setLoader(true);
      const colorPrice = customConfigData?.orderDetails?.find(
        (item) => item.uId === "c01"
      )?.Price;

      const newArray = structuredClone(customConfigData);

      const filterByColorCodeArr = newArray?.orderDetails?.filter(
        (x) => x.uId !== "c01"
      );

      const ModifiedExShowroom = [...filterByColorCodeArr]?.map((el) => {
        el.Price =
          el.Type === "Exshowroom"
            ? parseInt(el.Price) + colorPrice
            : parseInt(el.Price);

        return el;
      });

      // console.log("ModifiedExShowroom>>>>>", ModifiedExShowroom);

      setOrderSumery([...ModifiedExShowroom]);

      const filterByColorCode = newArray?.partNumber?.filter((x) =>
        newArray?.orderDetails?.some(
          (y) => y.Colour === x?.color?.toLowerCase()
        )
      );

      const getKitArr = newArray?.orderDetails
        ?.filter(
          (obj) => obj.ProductId.includes("k") && obj.ProductId.toUpperCase()
        )
        .map(
          (obj) => obj.ProductId.includes("k") && obj.ProductId.toUpperCase()
        );

      const selectedBtoKit = [...filterByColorCode]?.filter(
        (item) =>
          JSON.stringify(item.kit.sort()) === JSON.stringify(getKitArr.sort())
      );

      const selectedBtoColor = [...filterByColorCode]?.filter(
        (x) => x.kit.toString() == []
      );

      const orderDetailsArray = newArray?.orderDetails?.filter(
        (x) => x.Type !== "BTO"
      );

      if (selectedBtoKit?.length === 0) {
        selectedBtoColor?.map((x) => {
          orderDetailsArray.push({
            ProductName: x.partName,
            ProductId: x.partNumber,
            Quantity: 1,
            Colour: "",
            Price: x.price,
            Type: x.type,
          });
        });
      } else {
        selectedBtoKit?.map((x) => {
          orderDetailsArray.push({
            ProductName: x.partName,
            ProductId: x.partNumber,
            Quantity: 1,
            Colour: "",
            Price: x.price,
            Type: x.type,
          });
        });
      }

      const isBto = [...orderDetailsArray]?.some(
        (el) =>
          el.Type === "BTO" &&
          parseInt(el.Price) !== 0 &&
          parseInt(el.Price) !== 6000
      );

      setOrderDetailsArr(orderDetailsArray);
      setBtoStatus(isBto);

      if (isBto) {
        try {
          setLoader(true);
          axios
            .get(
              ConfigBaseUrl() + `vehicle-order-count?vehicleCode=${VehicleCode}`
            )
            .then((response) => {
              if (response) {
                setOrderCounter(
                  parseInt(response?.data?.MaxBooking) -
                    parseInt(response?.data?.SuccessRecord)
                );
              }
              setLoader(false);
            });
        } catch (error) {
        } finally {
        }
      }
      setLoader(false);
    } catch (error) {
    } finally {
    }
  }, [customConfigData]);

  const onOrderPlace = () => {
    try {
      setLoader(true);
      setAcceptStatus(false);
      // const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));

      const partId = [...orderDetailsArr]?.find(
        (item) => item.Type === "BTO"
      )?.ProductId;

      const ExBtoPriceArr = [...orderDetailsArr]?.filter(
        (el) => el.Type === "BTO" || el.Type === "Exshowroom"
      );

      const productPriceMap = [...ExBtoPriceArr]?.reduce((result, item) => {
        result[item.ProductName] = item.Price.toString();
        return result;
      }, {});

      const accessoriesArr = [...orderDetailsArr]?.filter(
        (x) => x.Type === "Accessories" || x.Type === "Combo Pack"
      );

      const accessoriesModifiedArr = [];
      accessoriesArr?.map((x) => {
        accessoriesModifiedArr.push({
          ProductName: x.ProductName,
          ProductId: x.ProductId?.toUpperCase(),
          VariantId: "",
          Quantity: 1,
          Colour: "",
          Price: x.Price,
        });
      });

      const merchandiseArr = [...orderDetailsArr]?.filter(
        (x) => x.Type === "Merchandise"
      );

      // console.log("userData ORDER22>>>>", userData);

      const body = {
        OrderVehicle: 1,
        OrderAccessories: 1,
        Token: userData?.Token,
        SessionId: "session120210614123",
        UserId: userData?.UserId,
        Name: userData?.FullName,
        Phone: userData?.MobileNumber,
        Email: userData?.Email,
        CustomVehicleName: "NA",
        VehicleCode: "NA",
        VehicleName: VehicleName,
        VariantCode: VehicleCode,
        VariantName: "NA",
        ColorCode: "NA",
        ColorName: "NA",
        PartId: partId,
        City: "NA",
        State: "NA",
        TotalPrice: "NA",
        VehiclePrice: "NA",
        BTO: {
          Status: btoStatus,
        },
        PreBooking: prebookData,
        Price: productPriceMap,
        AccessoriesData: accessoriesModifiedArr,
        MerchandiseData: merchandiseArr,
        AppProvider: "zini",
      };

      // console.log("Order Summary Payload >>>>>>> ", body);

      if (productPriceMap?.ExShowroom > 0) {
        axios({
          method: "post",
          url: ConfigBaseUrl() + "place-order",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: body,
        })
          .then((res) => {
            if (res?.status === 200) {
              onOrderModal(false);

              const newTab = window.open(res?.data?.RedirectUrl, "_blank");
              if (newTab) {
                newTab.focus();
              } else {
                alert(
                  "The pop-up was blocked. Please allow pop-ups for this website."
                );
              }
              setLoader(false);
            } else {
              setLoader(false);
              onOrderModal(false);
            }
          })
          .catch((error) => {
            setLoader(false);
            console.log("Error", error);
            alert("Please check your internet connection and try again");
          });
      }
    } catch (error) {
      setLoader(false);
      onOrderModal(false);
    } finally {
    }
  };

  useEffect(() => {
    const kitValue = customConfigData?.kits?.some((e) => e.status === true);

    setKitStaus(kitValue);

    if (kitValue) {
      customConfigData?.orderDetails?.filter(
        (element) =>
          element.name === "ExShowroom" && (element.includeBike = kitValue)
      );
    }
    const bikeStatus = customConfigData?.orderDetails?.some(
      (e) => e.name === "ExShowroom" && e.includeBike === true
    );
    setToggleSwitch(bikeStatus);
  }, [customConfigData]);

  const onToggleChange = (value) => {
    setToggleSwitch(value);

    customConfigData?.orderDetails?.filter(
      (element) =>
        element.name === "ExShowroom" && (element.includeBike = value)
    );

    dispatch(setCustomConfigData(structuredClone(customConfigData)));
  };

  const onRemoveCart = (partNumber) => {
    customConfigData?.merchandise?.map((element) => {
      if (element.ProductCode === partNumber) {
        element.cartStatus = false;
        element.countValue = 0;
      }
    });

    const hasProductId = customConfigData?.orderDetails?.some(
      (item) => item.ProductId === partNumber
    );
    if (hasProductId) {
      customConfigData.orderDetails.splice(
        customConfigData.orderDetails.findIndex(
          (item) => item.ProductId === partNumber
        ),
        1
      );
    }

    dispatch(setCustomConfigData(structuredClone(customConfigData)));
  };

  return (
    <>
      {loader ? (
        <ComponentLoader color={"#FFE100"} />
      ) : (
        <div
          className="order_modal_container"
          style={{
            zIndex: "1",
            position: "relative",
            width: "60vw",
            // borderRadius: "0.5625rem",
            // backgroundColor: "#000",
            // border: "1px solid #FFE100",
            // display: " flex",
            // flexDirection: "column",
          }}
        >
          <div
            className="close-icon"
            onClick={() => {
              onOrderModal(false);
            }}
          >
            <img src={crossicon} style={{ width: "1.7rem" }} alt="cancel-btn" />
          </div>

          <div className="order-header mediumFont">
            Order Summary{" "}
            {/* <ToggleSwitch
          label={"Include Bike?"}
          toggleSwitch={toggleSwitch}
          onToggleChange={onToggleChange}
          kitStaus={kitStaus}
        /> */}
          </div>

          {btoStatus && orderCounter === 0 && (
            <div
              // style={{ color: "#ff0000" }}
              className="partNumText mediumFont"
            >
              {/* BTO slots are full please come back next month! <br></br>Remove
              BTO kit to book a base bike! */}
              BTO slots sold out for the month! Your order is being confirmed to
              be processed next month.
            </div>
          )}

          {btoStatus && orderCounter > 0 && (
            <div className="partNumText mediumFont">
              Place your Order Now, slots are available.
              {/* -{orderCounter} */}
            </div>
          )}

          <div className="table">
            {orderSumery?.map((item, key) => (
              <>
                {/* // if (item?.includeBike === false) {
              // } else {
              // return ( */}
                <div className="row" key={key}>
                  <div className="column mediumFont">
                    {item?.ProductName === "ExShowroom"
                      ? "Ex Showroom"
                      : item?.ProductName}
                    {item?.Type === "Merchandise" && item?.Quantity && (
                      <> ({item?.Quantity})</>
                    )}
                    {item?.Type === "Merchandise" && item?.Size && (
                      <> - {item?.Size}</>
                    )}
                  </div>
                  {/* <div className="column mediumFont">{item.Colour}</div> */}

                  <div className="column mediumFont">
                    Rs {item?.Price?.toLocaleString("en-IN").replace(/,/g, " ")}
                    /-
                    {item?.Type === "Merchandise" && (
                      <img
                        src={removeCart}
                        className="remove_cart"
                        onClick={() => onRemoveCart(item?.ProductId)}
                      ></img>
                    )}
                  </div>
                </div>
                {/* // );
              // } */}
              </>
            ))}
          </div>

          <div className="cart_total">
            <div className="column mediumFont" style={{ fontWeight: 600 }}>
              Order Total Amount
            </div>

            {customConfigData?.orderDetails && (
              <div className="column mediumFont" style={{ fontWeight: 600 }}>
                Rs{" "}
                {totalPrice(customConfigData)
                  ?.toLocaleString("en-IN")
                  .replace(/,/g, " ")}
                /-
              </div>
            )}
          </div>

          <div className="policy_term">
            <div className="order_checkbox_flexbox">
              <label className="order_checkbox">
                <input
                  type="checkbox"
                  className="order_checkbox_input"
                  defaultChecked={checked}
                  onChange={() => setChecked(!checked)}
                />
                <span className="checkmark"></span>
              </label>
              <div className="Privacy mediumFont">
                I accept
                <span className="text_blue" onClick={TermsClick}>
                  Terms and Conditions
                </span>
                and
                <span className="text_blue" onClick={PrivacyClick}>
                  Privacy Policy
                </span>
              </div>
            </div>

            <PrimaryButton
              label={"Place Order"}
              loading={loader}
              className="place_order_btn mediumFont"
              size="small"
              disabled={true}
              style={{
                background:
                  checked && btoStatus
                    ? "#FFE100"
                    : checked && btoStatus
                    ? "#d0d0d0"
                    : checked && !btoStatus
                    ? "#FFE100"
                    : "#d0d0d0",

                pointerEvents:
                  checked && btoStatus
                    ? "auto"
                    : checked && btoStatus
                    ? "none"
                    : checked && !btoStatus
                    ? "auto"
                    : "none",
              }}
              // style={{
              //   background:
              //     checked && btoStatus && orderCounter > 0
              //       ? "#FFE100"
              //       : checked && btoStatus && orderCounter === 0
              //       ? "#d0d0d0"
              //       : checked && !btoStatus
              //       ? "#FFE100"
              //       : "#d0d0d0",

              //   pointerEvents:
              //     checked && btoStatus && orderCounter > 0
              //       ? "auto"
              //       : checked && btoStatus && orderCounter === 0
              //       ? "none"
              //       : checked && !btoStatus
              //       ? "auto"
              //       : "none",
              // }}
              onClick={() => {
                setAcceptStatus(true);
              }}
            />
          </div>
          {/* <div className="disclaimer mediumFont">
        Order will be handled by TVS Motor premium dealership
      </div> */}
        </div>
      )}

      {acceptStatus && (
        <>
          <div
            className="tooltip_bg"
            style={{
              display: " flex",
              alignItems: "center",
              justifyContent: "center",
              opacity: 1,
              zIndex: 5,
              width: "100%",
              height: "100%",
            }}
          >
            <div
              className="order_modal_container"
              style={{
                zIndex: "2",
                position: "fixed",
                maxWidth: "40vw",
              }}
            >
              <div
                className="close-icon"
                onClick={() => {
                  setAcceptStatus(false);
                }}
              >
                <img
                  src={crossicon}
                  style={{ width: "1.7rem" }}
                  alt="cancel-btn"
                />
              </div>

              <div className="accept_text mediumFont">
                <div className="accept_text_header mediumFont">Note:</div>
                <ul>
                  {acceptMessage?.map((item) => (
                    <li>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="accept_btn_container">
                <PrimaryButton
                  label={"ACCEPT"}
                  loading={loader}
                  className="place_order_btn mediumFont"
                  size="small"
                  style={{
                    background: "#FFE100",
                  }}
                  onClick={() => {
                    onOrderPlace();
                  }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default PlaceOrder;
